import React from 'react';
import { Theme, createStyles, WithTheme, WithStyles, withTheme, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Box } from '@material-ui/core';
import dayjs from './RosterDayJS';
import { withData } from './WithData';
import RosterViewport from './RosterViewport';
import { app } from './azuread';

interface TabPanelProps {
    children?: React.ReactNode,
    index: any,
    value: any
}

class TabPanel extends React.PureComponent<TabPanelProps> {
    render() {
        const { children, value, index, ...other} = this.props;

        return (
            <div
              role="tabpanel"
              hidden={value !== index}
              id={`scrollable-auto-tabpanel-${index}`}
              aria-labelledby={`scrollable-auto-tab-${index}`}
              {...other}
            >
              {value === index && (
                <Box>
                  {children}
                </Box>
              )}
            </div>
          );
    }
}

function a11yProps(index: any) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const styles = ({ palette }: Theme) => createStyles({
    root: {
      flexGrow: 1,
      width: '100%',
      backgroundColor: palette.background.paper,
    }
  });
  
interface RosterNavigationAppBarProps {
  selected?: number
}

interface RosterNavigationAppBarState {
  value?: number,
  isLg: boolean
}

const weeks = (() => {
  const weeks = [];
  for (let i = -1; i < 6; i++) {
    const monday = dayjs().startOf('isoWeek');
    const week = monday.add(i * 7, 'd');
    weeks.push(week);
  }
  return weeks;
})();

type Props = RosterNavigationAppBarProps & WithStyles<typeof styles> & WithTheme;

const RosterViewportWithData = withData(RosterViewport, app);

class RosterNavigationAppBar extends React.Component<Props, RosterNavigationAppBarState> {

  private readonly isLgMediaQuery: MediaQueryList;

  constructor(props: Props) {
    super(props);
    this.isLgMediaQuery = window.matchMedia(props.theme.breakpoints.up('lg').substr('@media '.length));
    this.state = { isLg: this.isLgMediaQuery.matches };
    
  }

  private readonly handleChange = (event: React.ChangeEvent<{}>, newValue: number) => this.setState(prev => ({ ...prev, value: newValue }));

  private readonly handleScreenSizeChange = (ev: MediaQueryListEvent) => {
    this.setState({ isLg: ev.matches });
  }

  componentDidMount() {
    this.isLgMediaQuery.addEventListener("change", this.handleScreenSizeChange);
  }

  componentWillUnmount() {
    this.isLgMediaQuery.removeEventListener("change", this.handleScreenSizeChange);
  }

  render() {
    const value = this.state.value ?? this.props.selected ?? 0;
    const { classes } = this.props;
    const { isLg } = this.state;

    const responsiveProps: { } = isLg
      ? { centered: true } 
      : { variant: 'scrollable' }

    return (
      <div className={classes.root}>
        <AppBar position="sticky" color="default">
          <Tabs
            value={value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            { ...responsiveProps }
          >
            <Tab label="Last Week" {...a11yProps(0)} />
            <Tab label="This Week" {...a11yProps(1)} />
            <Tab label="Next Week" {...a11yProps(2)} />
            <Tab label={weeks[3].format("[WC] DD/MM")} {...a11yProps(3)} />
            <Tab label={weeks[4].format("[WC] DD/MM")} {...a11yProps(4)} />
            <Tab label={weeks[5].format("[WC] DD/MM")} {...a11yProps(5)} />
            <Tab label={weeks[6].format("[WC] DD/MM")} {...a11yProps(6)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <RosterViewportWithData startDate={weeks[0].toDate()}></RosterViewportWithData>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <RosterViewportWithData startDate={weeks[1].toDate()}></RosterViewportWithData>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <RosterViewportWithData startDate={weeks[2].toDate()}></RosterViewportWithData>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <RosterViewportWithData startDate={weeks[3].toDate()}></RosterViewportWithData>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <RosterViewportWithData startDate={weeks[4].toDate()}></RosterViewportWithData>
        </TabPanel>
        <TabPanel value={value} index={5}>
          <RosterViewportWithData startDate={weeks[5].toDate()}></RosterViewportWithData>
        </TabPanel>
        <TabPanel value={value} index={6}>
          <RosterViewportWithData startDate={weeks[6].toDate()}></RosterViewportWithData>
        </TabPanel>
      </div>
    );
  }
}

export default withTheme(withStyles(styles)(RosterNavigationAppBar));